<script setup lang="ts">
import { PhxsgCoreDivider } from '@sg-core/src/View/Components/Atoms/Divider';
import { PhxsgWrapper } from '@sg-core/src/View/Components/Atoms/Wrapper';

type PhxsgDividerSpacing = 'md' | 'lg' | 'tight' | null;

interface PhxsgDividerProps {
  dark?: boolean;
  spacing?: PhxsgDividerSpacing;
  wrapped?: boolean;
}
const { dark = false, spacing = null, wrapped = false } = defineProps<PhxsgDividerProps>();

defineOptions({ inheritAttrs: false });
</script>

<template>
  <PhxsgWrapper :if="wrapped" class="phxsg-divider-wrapper">
    <PhxsgCoreDivider
      :class="[
        {
          'phxsg-divider--dark': dark,
          [`phxsg-divider--${spacing}`]: spacing,
        },
      ]"
      v-bind="{ ...$attrs }"
    />
    <slot />
  </PhxsgWrapper>
</template>

<style src="./divider.css" />
